<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Gestão de Vinculo") }}
      </h1>
    </div>
    <load v-if="loading" />
    <div v-else class="col-md-12">
      <div class="card mb-0 shadow card-body">
        <div class="row">
          <div class="col-md-12">
            <h4>Resumo do Grupo</h4>
            <table class="table table-bordered bg-white table-sm">
              <tbody>
                <tr>
                  <td colspan="3">
                    Nome do Grupo:
                    <b>{{ grupo.nome_grupo }}</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ $t("Protocolo") }}:
                    <b>{{ grupo.protocolo }}</b>
                    <b-link
                      v-b-tooltip.hover
                      title="Voltar para o Grupo"
                      :to="
                        '/dashboard/scfv/edit/' +
                        grupo.id +
                        '?page=usuariosvinculado'
                      "
                      target="_blank"
                    >
                      <i class="fas fa-external-link-alt"></i>
                    </b-link>
                  </td>
                  <td>
                    Criado: <b>{{ grupo.cadastrado }}</b>
                  </td>
                  <td>
                    Atualizado:
                    <b>{{ grupo.atualizado }}</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    Técnico responsável:
                    <b v-if="grupo.responsavel">{{ grupo.responsavel.name }}</b>
                  </td>
                  <td>
                    Unidade:
                    <b v-if="grupo.unidade">{{ grupo.unidade.nome }}</b>
                  </td>
                  <td>
                    Status:
                    <b v-if="grupo.unidade" v-html="grupo.status_nome"></b>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Faixa Etária dos Usuários:
                    <b>{{ grupo.faixa_etaria_nome }}</b>
                  </td>
                  <td>
                    Inscritos:
                    <b>{{ grupo.inscritos }}/{{ grupo.numero_vagas }}</b>

                    <b-link
                      href="#"
                      v-if="grupo.inscritos >= grupo.numero_vagas"
                      v-b-tooltip.hover
                      title="Atingiu limite de inscritos!"
                    >
                      <b-icon
                        icon="exclamation-triangle-fill"
                        variant="warning"
                        animation="fade"
                      ></b-icon>
                    </b-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <h4>Resumo do Usuário</h4>
            <table
              class="table b-table b-table-stacked-md table-bordered bg-white table-sm"
              v-if="usuario"
            >
              <tbody>
                <tr>
                  <td colspan="2">
                    Nome do Usuário:
                    <b>{{ usuario.nome_completo }}</b>
                  </td>
                  <td colspan="2">
                    Filiação 1: <b>{{ usuario.mae }}</b>
                  </td>
                </tr>
                <tr v-if="usuario.documento">
                  <td>
                    CPF: <b>{{ usuario.documento?.cpf || '' }}</b>
                  </td>
                  <td>
                    NIS: <b>{{ usuario.documento?.nis || '' }}</b>
                  </td>
                  <td>
                    Cor/Raça:
                    <b
                      v-for="cor_raca in $root.arrays.cor_raca"
                      :key="cor_raca.id"
                    >
                      <span v-if="cor_raca.id == usuario.cor_raca">{{
                        cor_raca.value
                      }}</span>
                    </b>
                  </td>
                  <td>
                    Sexo:
                    <b v-if="usuario.sexo == 1">Masculino</b>
                    <b v-if="usuario.sexo == 2">Feminino</b>
                    <b v-else>Intersexo</b>
                  </td>
                </tr>
                <tr v-if="usuario.familia">
                  <td colspan="2">
                    Família:
                    <strong>
                      <span v-if="usuario.codigo_familiar">
                        Código Cadúnico:
                        {{ usuario.codigo_familiar }}
                      </span>
                      <span v-else>ID{{ usuario.familia_id }}</span>
                    </strong>
                  </td>
                  <td colspan="2">
                    Responsável Familiar:
                    <b>{{ usuario.familia.responsavel_familiar?.nome_completo || '' }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="historicoStatus == false && evolucoes != true">
          <form @submit.prevent="submitVinculo" ref="submitVinculo">
            <div class="row">
              <form-select
                v-model="item.situacao_prioritaria"
                grid="12"
                label="Selecione uma Situação Prioritária"
                :itens="situacoes_prioritarias"
                :required="true"
                @change="situacaoPrioritariaSelecionada"
                ajuda="Essa situação precisa do parecer técnico e o mesmo deve ser inserido em até 30 dias após a inserção do usuário no serviço."
                :multiple="true"
                :disabled="
                  statusAnterior == 2 || user_id != grupo.responsavel.id
                    ? true
                    : false
                "
              />

              <form-input
                v-if="campoExtra"
                v-model="item.outra_situacao"
                grid="12"
                label="Outra Situação Prioritária"
                :required="true"
                :disabled="
                  statusAnterior == 2 || user_id != grupo.responsavel.id
                    ? true
                    : false
                "
              />

              <form-select
                @change="verificarStatus"
                v-model="item.status"
                label="Status"
                grid="4"
                :itens="$root.arrays.scfv_status_vinculos"
                :disabled="
                  statusAnterior == 2 ||
                  (user_id != grupo.responsavel.id &&
                    $store.state.user.role_details.name != 'Gestor(a)' &&
                    $store.state.user.role_details.name != 'Coordenador' &&
                    $store.state.user.role_details.name !=
                      'Técnico(a) de Nível Superior')
                    ? true
                    : false
                "
              />

              <form-file
                label="Anexar Parecer Técnico"
                grid="8"
                @submit="submitFile"
                multiple
                btn-text="Iniciar"
                :progress="progressCompleted"
                :disabled="
                  statusAnterior == 2 || user_id != grupo.responsavel.id
                    ? true
                    : false
                "
              />
            </div>
            <div class="row pt-4 px-0 d-flex justify-content-end">
              <div class="col-auto px-2 text-right">
                <a
                  class="router-link-exact-active active px-3"
                  @click="historicoStatus = true"
                >
                  <i class="fas fa-history"></i> Histórico de Status
                </a>
                <router-link
                  :to="
                    '/dashboard/scfv/edit/' +
                    grupo.id +
                    '?page=usuariosvinculado'
                  "
                  class="btn btn-default"
                >
                  <i class="mdi mdi-arrow-left" />
                </router-link>
                <button
                  class="btn btn-primary"
                  data-style="zoom-in"
                  type="button"
                  @click="evolucoes = true"
                >
                  <i class="fas fa-sort-amount-up"></i>
                  {{ $t("Evolução") }}
                </button>
                <button
                  class="btn btn-success btn-submit"
                  data-style="zoom-in"
                  type="submit"
                  :disabled="statusAnterior == 2 ? true : false"
                >
                  <i class="mdi mdi-content-save" />
                  {{ $t("Salvar") }}
                </button>
              </div>
            </div>
            <div v-if="item.anexos">
              <anexos :anexos="item.anexos" />
            </div>
          </form>
        </div>

        <div class="row" v-else>
          <HistoricoStatus
            @voltar="historicoStatus = false"
            :id="item.id"
            :familia="0"
            :status="status_item"
            v-if="evolucoes != true"
          />
        </div>

        <Evolucao v-if="evolucoes" :usuario="usuario" :grupo="grupo" />
      </div>
    </div>
    <status-historico
      :model="model"
      modulo="Scfv"
      titulo_modulo="SCFV INSCRIÇÃO"
      :id="item.id"
      :status-anterior="statusAnterior"
      :status-atual="statusAtual"
      :status="status_item"
      :save-handler="submitVinculo"
      @reload="cancelarStatus"
    />
  </div>
</template>
<script>
import Header from "../../../Header";
import Evolucao from "./Evolucao";
import HistoricoStatus from "./HistoricoStatus";
export default {
  name: "EditVinculo",
  components: {
    Header,
    HistoricoStatus,
    Evolucao,
  },
  data() {
    return {
      loading: true,
      item: {
        usuario_id: null,
        scfv_grupo_id: null,
      },
      grupo: {},
      usuario: {},
      campoExtra: false,
      files: [],
      statusAtual: "",
      statusAnterior: "",
      historicoStatus: false,
      status: {},
      status_item: [],
      model: "ScfvGruposVinculo",
      progressCompleted: 0,
      evolucoes: false,
      user_id: null,
      situacoes_prioritarias: [],
    };
  },
  mounted() {
    this.status_item = this.$root.arrays.scfv_status_vinculos;
    this.getGrupo();
    this.getItem();
    this.getItensSituacoesPrioritarias();
  },
  methods: {
    submitFile(files) {
      this.files = files;
    },
    situacaoPrioritariaSelecionada(value) {
      const idOutro = this.situacoes_prioritarias.find(situacao => situacao.value === "OUTRAS")?.id;

      this.campoExtra = Array.isArray(value) && value.includes(idOutro);
    },
    cancelarStatus() {
      this.item.status = this.statusAnterior;
      this.statusAtual = this.statusAnterior;
    },
    submitVinculo(historico = null) {
      const alterandoStatus = this.item.status != this.statusAnterior;
      if (alterandoStatus && !historico?.data) {
        this.verificarStatus(this.item.status);
        return;
      }
      let formData = new FormData();

      if (this.files.length > 0 && this.files.length != undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("files[]", this.files[i]);
        }
      } else {
        formData.append("files", this.files);
      }

      for (const key of ["id", "status", "outra_situacao"]) {
        if (this.item[key] != null) formData.append(key, this.item[key]);
      }
      for (const situacao of this.item.situacao_prioritaria || []) {
        formData.append("situacao_prioritaria[]", situacao);
      }
      if (historico?.data) {
        for (const key of ["data", "motivo", "observacoes"]) {
          if (historico[key] != null && historico[key] !== "") {
            formData.append(`historico[${key}]`, historico[key]);
          }
        }
      }

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      return axios
        .post(`api/dashboard/update/scfvvinculo`, formData, {
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          this.statusAnterior = this.item.status;
          this.getGrupo();
          this.getItem();
          this.files = [];
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .catch((error) => {
          const mensagem = Object.values(error.response?.data?.errors || {}).flat().join(" ");
          swal.fire({
            title: "Não foi possível salvar o vínculo",
            text: mensagem || error.response?.data?.error?.message || "Tente novamente.",
            icon: "error",
          });
          if (historico?.data) throw error;
        })
        .finally(() => {
          ladda.stop();
          this.progressCompleted = 0;
        });
    },
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/scfvvinculo/${this.$route.params.vinculo}`)
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.item = response.data.data;
          this.statusAnterior = this.item.status;
        })
        .finally(() => {
          this.getUsuario(this.item.usuario_id);
          this.situacaoPrioritariaSelecionada(this.item.situacao_prioritaria);
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
    getGrupo() {
      axios
        .get(`api/dashboard/scfv/${this.$route.params.id}`)
        .then((response) => {
          this.grupo = response.data.data;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
    getUsuario(id) {
      axios
        .get(`api/dashboard/usuarios/${id}`)
        .then((response) => {
          this.usuario = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
    verificarStatus(status) {
      this.statusAtual = status;

      if (this.statusAtual != this.statusAnterior) {
        this.$bvModal.show("status-historico-" + this.model);
      }
    },
    getItensSituacoesPrioritarias() {
      axios
      .get(`api/dashboard/situacoes_prioritarias_ativas`)
      .then((response) => {
        this.situacoes_prioritarias = response.data.map((elem) => ({
          id: elem.id,
          value: elem.descricao,
        }));
      })
    },
  },
};
</script>
